/**
 * Named text styles
 *
 * @see https://chakra-ui.com/docs/styled-system/text-and-layer-styles
 */
export const textStyles = {
  headline: {
    fontFamily: 'heading',
    fontSize: ['xxl', 'xxxxxl'],
    fontWeight: 400,
    lineHeight: '0.933em',
    letterSpacing: 'tight',
  },
  quote: {
    fontFamily: 'heading',
    fontSize: 'xl',
    fontWeight: 400,
    lineHeight: '1em',
    letterSpacing: 'tight',
  },
  heading: {
    fontFamily: 'heading',
    fontSize: 'xxl',
    fontWeight: 400,
    lineHeight: '0.933em',
    letterSpacing: 'tight',
  },
  subHeadline: {
    fontFamily: 'body',
    fontWeight: 500,
    fontSize: 'lg',
    lineHeight: '1em',
  },
  subHeading: {
    fontFamily: 'body',
    fontWeight: 500,
    fontSize: 'sm',
    lineHeight: '1.2em',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'md',
    lineHeight: '1.2em',
  },
  detail: {
    fontFamily: 'mono',
    fontSize: 'xs',
    textTransform: 'uppercase',
    letterSpacing: 'wider',
  },
  cta: {
    fontFamily: 'mono',
    textTransform: 'uppercase',
    letterSpacing: 'wider',
  },
}

/**
 * Global styles
 *
 * @see https://chakra-ui.com/docs/styled-system/global-styles
 */
export const styles = {
  global: {
    html: {
      // this calculation has been taken from the webflow implementation for sake
      // of consistency and appears to work quite well when sizing/spacing layout
      // using rem + vw unit values
      fontSize: 'calc(0.625rem + 0.41666666666666663vw)',
    },
    '@media screen and (max-width: 64rem)': {
      html: {
        fontSize: 'inherit',
      },
    },
    body: {
      backgroundColor: 'softBlack',
      color: 'softBlack',
    },
    a: {
      color: 'inherit',
      textDecoration: 'none',
    },
    '*::placeholder': {
      color: 'softerBlack',
    },
    'select:invalid': {
      color: 'orange',
    },
  },
}

/**
 * Named layer styles
 *
 * @see https://chakra-ui.com/docs/styled-system/text-and-layer-styles
 */
export const layerStyles = {
  white: {
    bg: 'white',
    color: 'softBlack',
  },
  orange: {
    bg: 'orange',
    color: 'softBlack',
    borderColor: 'orange',
  },
  softOrange: {
    bg: 'softOrange',
    color: 'softBlack',
    borderColor: 'softOrange',
  },
  softerOrange: {
    bg: 'softerOrange',
    color: 'softBlack',
    borderColor: 'softerOrange',
  },
  softestOrange: {
    bg: 'softestOrange',
    color: 'softBlack',
    borderColor: 'softestOrange',
  },
  orangeDisabled: {
    color: 'softerBlack',
    bg: 'softerOrange',
    cursor: 'default',
  },
  softWhite: {
    bg: 'softWhite',
    borderColor: 'softWhite',
    color: 'softBlack',
  },
  softerWhite: {
    bg: 'softerWhite',
    borderColor: 'softerWhite',
    color: 'softBlack',
  },
  softestWhite: {
    bg: 'softestWhite',
    borderColor: 'softestWhite',
    color: 'softBlack',
  },
  softBlack: {
    bg: 'softBlack',
    borderColor: 'softBlack',
    color: 'softWhite',
  },
  softBlackDisabled: {
    color: 'softestBlack',
    borderColor: 'softerBlack',
    bg: 'softerBlack',
    cursor: 'default',
  },
  outlined: {
    bg: 'transparent',
    color: 'softBlack',
    borderColor: 'softBlack',
    borderWidth: '1px',
  },
  outlinedDashed: {
    bg: 'transparent',
    color: 'gray',
    borderColor: 'gray',
    borderWidth: '2px',
    borderStyle: 'dashed',
  },
  outlinedDisabled: {
    color: 'softestBlack',
    borderColor: 'softestBlack',
    cursor: 'default',
  },
  blue: {
    bg: 'blue',
    borderColor: 'blue',
    color: 'softBlack',
  },
  blush: {
    bg: 'blush',
    borderColor: 'blush',
    color: 'softBlack',
  },
  gray: {
    bg: 'gray',
    color: 'softBlack',
    borderColor: 'gray',
  },
  green: {
    bg: 'green',
    color: 'softerWhite',
    borderColor: 'green',
  },
  softGreen: {
    bg: 'softGreen',
    color: 'softBlack',
    borderColor: 'softGreen',
  },
  steel: {
    bg: 'steel',
    borderColor: 'steel',
    color: 'white',
  },
  lilac: {
    bg: 'lilac',
    borderColor: 'lilac',
    color: 'softBlack',
  },
  fail: {
    bg: 'failRed',
    borderColor: 'failRed',
    color: 'white',
  },
  success: {
    bg: 'successGreen',
    borderColor: 'successGreen',
    color: 'white',
  },
}
